import React from "react";

const DeletePageHeader = ({ type, partNumber, status, revision, isProcedureSelected }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "20px",
        padding: "8px 20px",
        flexWrap: "wrap", // for responsiveness
      }}
    >
      {/* Checkbox + Title + Description */}
      <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <label
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
            margin: 0,
          }}
        >
          <span style={{ fontSize: "16px", fontWeight: 600 }}>
            {type} {partNumber}
          </span>
          {isProcedureSelected && (
            <span
              style={{
                marginLeft: "12px",
                fontSize: "14px",
                color: "#666",
                fontStyle: "italic",
              }}
            >
              {/* (Copy to end) */}
            </span>
          )}
        </label>
      </div>

      {/* Right-aligned section */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginLeft: "auto",
        }}
      >
        <div>
          <strong>Status: </strong>
          <span style={{ color: "orange" }}>{status}</span>
        </div>

        <div>
          <strong>Revision: </strong>
          <span>{revision}</span>
        </div>
      </div>
    </div>
  );
};

export default DeletePageHeader;
